import { render } from "./StampaPrenotati.vue?vue&type=template&id=476ba5bd&scoped=true"
import script from "./StampaPrenotati.vue?vue&type=script&lang=js"
export * from "./StampaPrenotati.vue?vue&type=script&lang=js"

import "./StampaPrenotati.vue?vue&type=style&index=0&id=476ba5bd&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476ba5bd"]])

export default __exports__